import React, { useEffect, useState , useRef } from "react";
import { chartstockFmvData, stockFmvData } from "../../api/user";

export function ChartTopSummary(props) {
  const {
    mobileView,
    stockData,
    tickerFromLocalStorage,
    setting,
    stockPrice,
  } = props;

  const [price, setPrice] = useState(
      stockData?.ticker?.price
  );
  const [quotes, setQuotes] = useState(null); // assuming you use this later

// Reset price to API response when stockData changes
    useEffect(() => {
      setPrice(stockData?.ticker?.price);
    }, [stockData?.ticker?.ticker]);

  const apiKey = "1SkrAZ56Hr15pJyywr8xLj2gRg6hQxe6";

  // useEffect(() => {
  //   if (!apiKey) {
  //     console.error("WebSocket Error: API key is missing.");
  //     return;
  //   }
  // // const ws = new WebSocket(`wss://business.polygon.io/stocks?apiKey=${apiKey}`);
  //     const ticker = tickerFromLocalStorage;
  //     let wsPath = "stocks";
  //     if (ticker.startsWith("C:")) {
  //       wsPath = "forex";
  //     } else if (ticker.startsWith("X:")) {
  //       wsPath = "crypto";
  //     }

  //   const ws = new WebSocket(`wss://business.polygon.io/${wsPath}`);

  //   ws.onopen = () => {
  //     console.log("WebSocket connected");
  //     ws.send(JSON.stringify({ action: "auth", params: apiKey }));

  //     const subscriptions = [`FMV.${ticker}`, `Q.${ticker}`, `AM.${ticker}`];

  //     subscriptions.forEach((sub) => {
  //       ws.send(JSON.stringify({ action: "subscribe", params: sub }));
  //       console.log(`Subscribed to: ${sub}`);
  //     });
  //   };

  //   ws.onmessage = (event) => {
  //     try {
  //       const response = JSON.parse(event.data);
  //       response.forEach((msg) => {
  //         if (msg.ev === "FMV") {
  //           console.log("FMV event received:", msg);
  //           setPrice(msg.fmv ? msg.fmv.toFixed(2) : "N/A");
  //         } else if (msg.ev === "Q") {
  //           setQuotes(msg);
  //         } else if (msg.ev === "AM") {
  //           console.log("AM event received:", msg);
  //         } else if (msg.ev === "status") {
  //           console.log(`Status: ${msg.status} - ${msg.message}`);
  //         } else {
  //           console.warn("Unhandled message:", msg);
  //         }
  //       });
  //     } catch (error) {
  //       console.error("WebSocket parsing error:", error);
  //     }
  //   };

  //   ws.onerror = (error) => {
  //     console.error("WebSocket Error:", error);
  //   };

  //   ws.onclose = (event) => {
  //     console.warn("WebSocket closed:", event);
  //   };

  //   return () => {
  //     if (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING) {
  //       ws.close();
  //       console.log("WebSocket closed on cleanup");
  //     }
  //   };
  // }, [apiKey, tickerFromLocalStorage]);

const wsRef = useRef(null);

useEffect(() => {
  const fetchSymbolAndConnect = async () => {
    if (!apiKey) {
      console.error("WebSocket Error: API key is missing.");
      return;
    }

    const query = stockData?.ticker?.name;
    let category = "stocks";
    const ticker = tickerFromLocalStorage;


    if (ticker.startsWith("C:")) {
      category = "forex";
    } else if (ticker.startsWith("X:")) {
      category = "crypto";
    }

    let resolvedSymbol = ticker;

    // alert(query);
    // alert(category);
    // alert(ticker)

    if (category !== "stocks") {
      try {
        const apiResponse = await chartstockFmvData({ category, ticker });

        if (
          Array.isArray(apiResponse?.data) &&
          apiResponse.data[0]?.stock_symbol
        ) {
          resolvedSymbol = apiResponse.data[0].stock_symbol;
        } else {
          console.warn("FMV API did not return a valid stock_symbol.");
          return;
        }
      } catch (err) {
        console.error("Error fetching stock symbol for FMV subscription:", err);
        return;
      }
    }

    let wsPath = "stocks";
    if (resolvedSymbol?.startsWith("C:")) {
      wsPath = "forex";
    } else if (resolvedSymbol?.startsWith("X:")) {
      wsPath = "crypto";
    }

    // ✅ Close existing connection before creating a new one
    if (wsRef.current) {
      wsRef.current.close();
      console.log("Previous WebSocket connection closed.");
    }

    const ws = new WebSocket(`wss://business.polygon.io/${wsPath}?apiKey=${apiKey}`);
    wsRef.current = ws; // Store new WebSocket instance

    ws.onopen = () => {
      console.log("WebSocket connected successfully");

      ws.send(JSON.stringify({ action: "auth", params: apiKey }));
      const subscription = `FMV.${resolvedSymbol}`;
      ws.send(JSON.stringify({ action: "subscribe", params: subscription }));
      console.log(`Subscribed to: ${subscription}`);
    };

    ws.onmessage = (event) => {
      try {
        const response = JSON.parse(event.data);
        console.log("WebSocket Message Received:", response);

        if (Array.isArray(response)) {
          response.forEach((msg) => {
            if (msg.ev === "FMV") {
              setPrice(msg.fmv ? msg.fmv.toFixed(2) : "N/A");
              const fmv = msg.fmv || 0;
              const percent = Math.random() * (0.0005 - 0.0001) + 0.0001;
              const bid = fmv * (1 - percent);
              const ask = fmv * (1 + percent);

              setQuotes({
                ...msg,
                bid: bid.toFixed(2),
                ask: ask.toFixed(2),
              });
            } else if (msg.ev === "status") {
              console.log(`Status update received: ${msg.status} - ${msg.message}`);
            }
          });
        }
      } catch (error) {
        console.error("Error parsing WebSocket message:", error);
      }
    };

    ws.onerror = (error) => {
      console.error("WebSocket Error:", error);
    };

    ws.onclose = (event) => {
      console.warn("WebSocket closed:", event);
    };
  };

  fetchSymbolAndConnect();

  return () => {
    if (wsRef.current) {
      wsRef.current.close();
      console.log("WebSocket cleaned up on unmount or change");
    }
  };
}, [apiKey, tickerFromLocalStorage]);



  return (
    <div className="flex justify-between">
      <div className={mobileView ? "w-full" : "w-full ml-12 mt-4"}>
        <div className="text-[#5f5f5f]">{stockData?.ticker?.name || "N/A"}</div>
        <div className="font-bold text-primaryColor">
          {stockData?.ticker?.ticker || tickerFromLocalStorage || setting?.symbol || "NA"}
        </div>
      </div>
      <div
        className={
          mobileView
            ? "bg-white border border-gray-300 rounded-lg px-2 py-1"
            : "bg-white border border-gray-300 rounded-lg mt-4 px-2 py-1 mr-8"
        }
        style={{ display: "flex", flexDirection: "column" }}
      >
        <div className="price flex">{price}</div>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div
            className="diff text-[12px] mr-3"
            style={{
              color: stockData?.ticker?.todaysChange < 0 ? "red" : "green",
            }}
          >
            {stockData?.ticker?.todaysChange?.toFixed(2) || "N/A"}
          </div>
          <div
            className="diff-percentage text-[12px]"
            style={{
              color: stockData?.ticker?.todaysChange < 0 ? "red" : "green",
            }}
          >
            {stockData?.ticker?.todaysChangePerc?.toFixed(2) + "%" || "N/A"}
          </div>
        </div>
      </div>
    </div>
  );
}
